/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { CircleSpinner } from '@components/atoms'

interface PropsType {
	className?: string
}

export const BoxSpinnerView = (props: PropsType) => {
	return (
		<View css={style} className={props.className}>
			<CircleSpinner />
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',

	'.spinner': {
		margin: 'auto',
	},
})
